import { ContentBlock, ContentState } from 'draft-js';
import entityAtChar from './utils/entityAtChar';

export default function followupStrategy(
  contentBlock: ContentBlock,
  callback: (start: number, end: number) => void,
  contentState: ContentState,
) {
  contentBlock.findEntityRanges(
    (char) => entityAtChar(char, contentState).isFollowupEntity,
    callback,
  );
}
